<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3>{{ item.agentName ? item.agentName : '未填写' }}</h3>
          <!-- <h3 class="bq">套餐配置</h3> -->
          <van-button
            size="small"
            plain
            class="config-price-btn"
            :to="{ name: 'PackageConfigSub', query: { subAgentId: item.agentId,subAgentName: item.agentName ,customTitle:item.agentName} }"
          >
            套餐配置
            <van-icon name="arrow" />
          </van-button>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li>
              <h3>SIM卡</h3>
              <p>{{ item.cardQuantity ? item.cardQuantity : '0' }}</p>
            </li>
            <li>
              <h3>手机号</h3>
              <p>{{ item.mobile ? item.mobile : '未填写' }}</p>
            </li>
            <li>
              <h3>注册时间</h3>
              <p>{{ item.createTime }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'Recharge', params: { iccid: e } })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 280px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 20px;
    .title {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        h3 {
          font-size: 30px;
          color: #272729;
          line-height: 20px;
          font-weight: 400;
        }
        .bq {
          width: 130px;
          text-align: end;
          color: #9D9DA3;
        }
      }
      .methodSlidebt {
        ul {
          display: flex;
          justify-content: space-between;
          height: 70px;
          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9D9DA3;
            }
            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }
    .btn {
      flex: 1;
      text-align: center;
      padding-left: 45px;
      .van-button {
        width: 100px;
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-1.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }

/* ✅ 新增：配置售价按钮样式 */
.config-price-btn {
  flex-shrink: 0;
  white-space: nowrap;

  /* ✅ 核心尺寸：15px文字 + 36px高度，平衡可读性与克制感 */
  height: 36px !important;
  padding: 0 16px !important;
  font-size: 22px !important;
  line-height: 36px !important;
  border-radius: 8px !important;
  font-weight: 500;

  /* ✅ 业务强化：浅品牌绿底 + 品牌绿字 */
  /* background-color: rgba(7, 193, 96, 0.10) !important; */
  color: #07C160 !important;
  border: none !important;

  /* 图标适配 */
  :deep(.van-icon) {
    margin-right: 6px;
    font-size: 16px;
    vertical-align: middle;
  }

  /* 交互反馈：温和增强，不喧宾夺主 */
  &:hover {
    background-color: rgba(7, 193, 96, 0.15) !important;
  }
}
</style>
